import { render, staticRenderFns } from "./LgFinderPageLocalArmazenamento.vue?vue&type=template&id=16905000&scoped=true"
import script from "./LgFinderPageLocalArmazenamento.vue?vue&type=script&lang=js"
export * from "./LgFinderPageLocalArmazenamento.vue?vue&type=script&lang=js"
import style0 from "./LgFinderPageLocalArmazenamento.vue?vue&type=style&index=0&id=16905000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16905000",
  null
  
)

export default component.exports